import { useState, useEffect } from 'react';
import { fetchUserData } from '@/services/userService';

export const useUserData = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await fetchUserData();
        if (!cancelled) setData(res);
      }
      catch (e) {
        if (!cancelled) setError(e);
      }
      finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return { data, loading, error };
};
